module.exports = __webpack_public_path__ + "img/45d1e40d37cecceffea0b50c6b3fb436.svg";